import { Link, useNavigate } from "react-router-dom";
import { Instagram, MessageCircle, Music2 } from "lucide-react";
import { Logo } from "./Logo";
import { useSettings, waLink } from "@/context/SettingsContext";

export const Footer = () => {
  const s = useSettings();
  const navigate = useNavigate();
  const go = (id) => {
    if (window.location.pathname !== "/") navigate("/");
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 100);
  };

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8" data-testid="footer">
      <div className="max-w-6xl mx-auto px-5">
        <div className="grid gap-10 md:grid-cols-3">
          <div className="max-w-xs">
            <Logo dark />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              {s.footer_tagline}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6 text-sm">
            <div className="space-y-3">
              <button onClick={() => go("inicio")} className="block hover:text-white transition-colors">Inicio</button>
              <button onClick={() => go("servicios")} className="block hover:text-white transition-colors">Servicios</button>
              <button onClick={() => go("como-funciona")} className="block hover:text-white transition-colors">Cómo funciona</button>
            </div>
            <div className="space-y-3">
              <button onClick={() => go("faq")} className="block hover:text-white transition-colors">Preguntas frecuentes</button>
              <Link to="/consultar-pedido" className="block hover:text-white transition-colors">Consultar pedido</Link>
              <Link to="/soporte" className="block hover:text-white transition-colors">Soporte</Link>
              <a href={s.refill_url || "https://refil.perfilturbinado.com/"} target="_blank" rel="noreferrer" className="block hover:text-white transition-colors">Reposición de seguidores</a>
              <a href={waLink(s.whatsapp, "Hola, quiero más información sobre Aumenta Ya.")} target="_blank" rel="noreferrer" className="block hover:text-white transition-colors">Contacto</a>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold text-white mb-4">Seguinos</p>
            <div className="flex gap-3">
              <a href={`https://instagram.com/${(s.instagram || "").replace("@", "")}`} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full bg-slate-800 hover:bg-indigo-600 flex items-center justify-center transition-colors" data-testid="footer-instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href={waLink(s.whatsapp, "Hola Impulso Visual")} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full bg-slate-800 hover:bg-emerald-600 flex items-center justify-center transition-colors" data-testid="footer-whatsapp">
                <MessageCircle className="h-5 w-5" />
              </a>
              <a href={`https://tiktok.com/@${(s.tiktok || "").replace("@", "")}`} target="_blank" rel="noreferrer" className="h-10 w-10 rounded-full bg-slate-800 hover:bg-pink-600 flex items-center justify-center transition-colors" data-testid="footer-tiktok">
                <Music2 className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 text-center text-xs text-slate-500">
          © 2026 Impulso Visual. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};
